<template>
  <v-container grid-list-md class="text-center">
    <h1>Velkommen til agree.ly</h1>
  </v-container>
</template>

<script>
export default {}
</script>
